import defaultLogo from '../img/Logo.svg';

import { registerClass } from '../SatCoreRegistry';

export default class BannerService {
  /**
   * intended to be overridden by satellites
   */
  static generateFooterLinkMap = () => {
    return new Map([
      ['termsOfUse', 'www.example.com'],
      ['privacy', 'www.example.com'],
      ['support', 'www.example.com']
    ]);
  }

  /**
   * Intended to be overridden by satellites
   * Generate footer elements for minimal footer layout
   * Each element can be: 'contact', 'phone', 'separator', 'logo', or a link key
   */
  static generateFooterElements = () => {
    return [
      'logo',
      'contact',
      'separator',
      'phone', 
      'separator',
      'termsOfUse',
      'separator',
      'privacy'
    ];
  }

  /**
   * intended to be overridden by satellites
   */
  static getLogoInfo = () => {
    return {
      img: defaultLogo,
      url: ''
    };
  }

  /**
   * intended to be overridden by satellites
   */
  static getContactInfo = () => {
    return {
      email: '',
      phone: ''
    };
  }

  /**
   * intended to be overridden by satellites
   */
  static getCopyrightText = () => {
    return '';
  }
}

registerClass('BannerService', BannerService);
